import '../../sass/EEBusiness/index.scss'

const stepsNav = document.querySelector('.EEBusiness-AmlSteps')
const activeStep = stepsNav?.querySelector('a.Active')

if (stepsNav && activeStep && window.matchMedia('(max-width: 920px)').matches) {
    window.requestAnimationFrame(() => {
        activeStep.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: 'smooth',
        })
    })
}

document.querySelectorAll('.EEBusiness-AmlForm').forEach((form) => {
    const conditionalRows = Array.from(form.querySelectorAll('.js-ee-business-aml-conditional'))

    form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.defaultPrevented || !(event.target instanceof HTMLElement)) {
            return
        }

        const tagName = event.target.tagName
        if (!['INPUT', 'SELECT'].includes(tagName)) {
            return
        }

        if (['submit', 'button', 'reset'].includes(String(event.target.type || '').toLowerCase())) {
            return
        }

        const primarySubmit = form.querySelector('.EEBusiness-AmlActions .EEBusiness-AmlButton.Primary')
        if (!primarySubmit) {
            return
        }

        event.preventDefault()
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(primarySubmit)
        } else {
            primarySubmit.click()
        }
    })

    if (!conditionalRows.length) {
        return
    }

    function fieldValue(fieldName, fallbackValues = {}) {
        const inputs = Array.from(form.querySelectorAll(`[name="${fieldName}"]`))
        const checkedInput = inputs.find((input) => input.checked && !input.disabled)
        if (checkedInput) {
            return checkedInput.value
        }

        const input = inputs.find((field) => !field.disabled)
        if (input && ['checkbox', 'radio'].includes(input.type)) {
            return ''
        }

        if (input) {
            return input.value
        }

        if (inputs.length) {
            return ''
        }

        return Object.prototype.hasOwnProperty.call(fallbackValues, fieldName) ? fallbackValues[fieldName] : ''
    }

    function updateConditionalRows() {
        conditionalRows.forEach((row) => {
            let rules = []
            try {
                rules = JSON.parse(row.dataset.conditionalRules || '[]')
            } catch (error) {
                rules = []
            }

            let fallbackValues = {}
            try {
                fallbackValues = JSON.parse(row.dataset.conditionalAnswers || '{}')
            } catch (error) {
                fallbackValues = {}
            }

            const ruleMatches = rules.map((rule) => {
                const expectedValues = Array.isArray(rule.value) ? rule.value : [rule.value]
                return expectedValues
                    .map((value) => String(value).toLowerCase())
                    .includes(String(fieldValue(rule.key || '', fallbackValues)).toLowerCase())
            })
            const visible = row.dataset.conditionalMode === 'all'
                ? ruleMatches.every(Boolean)
                : ruleMatches.some(Boolean)

            row.hidden = !visible
            row.querySelectorAll('input, textarea, select').forEach((input) => {
                input.disabled = !visible
                input.required = visible && input.dataset.requiredWhenVisible === '1'
            })
        })
    }

    form.addEventListener('change', updateConditionalRows)
    updateConditionalRows()
})
